import { partialBind, } from 'remeda';
import { appointmentBookRequestValidate, } from './appointment/AppointmentApi.binding.js';
import { appointmentBook, searchBookableAppointments, } from './appointment/AppointmentApi.js';
import { loginRequestValidate, } from './auth/AuthApi.binding.js';
import { clientInvoiceDownloadInvoice, clientInvoiceDownloadRequestTan, } from './client/invoice/ClientInvoiceApi.js';
import { apiCall, } from './common/apiCall.js';
import { version, } from './common/CommonApi.js';
import { importedTherapistsDelete, importedTherapistsSearch, } from './user/ImportedTherapistsApi.js';
import { searchTherapist, } from './user/UserApi.js';
export { appointmentBookRequestValidate, appointmentBookResponseValidate, appointmentSaveRequestValidate, appointmentSaveResponseValidate, searchBookableAppointmentsRequestValidate, searchBookableAppointmentsResponseValidate, } from './appointment/AppointmentApi.binding.js';
export { appointmentSeriesInterval, appointmentState, isMedicalFeeScheduleLine, } from './appointment/AppointmentApi.js';
export { appointmentTypeLocation, } from './appointment/AppointmentTypeApi.js';
export { loginRequestValidate, loginResponseValidate, } from './auth/AuthApi.binding.js';
export { clientAccountDeleteResponseValidate, } from './client/account/ClientAccountApi.binding.js';
export { clientAccountDocumentDownloadResponseValidate, clientAccountDocumentSearchRequestValidate, clientAccountDocumentSearchResponseValidate, } from './client/account/document/ClientAccountDocumentApi.binding.js';
export { clientAccountInvoiceDownloadResponseValidate, clientAccountInvoiceSearchRequestValidate, clientAccountInvoiceSearchResponseValidate, } from './client/account/invoice/ClientAccountInvoiceApi.binding.js';
export { getClientRequestValidate, getClientResponseValidate, searchClientRequestValidate, searchClientResponseValidate, updateClientRequestValidate, } from './client/ClientApi.binding.js';
export { clientInvoiceDownloadInvoiceRequestValidate, clientInvoiceDownloadInvoiceResponseValidate, clientInvoiceDownloadTanRequestValidate, clientInvoiceDownloadTanResponseValidate, } from './client/invoice/ClientInvoiceApi.binding.js';
export { clientRegisterRequestTanRequestValidate, clientRegisterRequestTanResponseValidate, clientRegisterRequestValidate, clientRegisterResponseValidate, } from './client/register/ClientRegisterApi.binding.js';
export { configRequestValidate, configResponseValidate, versionRequestValidate, versionResponseValidate, } from './common/CommonApi.binding.js';
export { countries, } from './countries.js';
export { createSelfServiceRequestValidate, customerPaymentInfoRequestValidate, customerPaymentInfoResponseValidate, } from './customer/CustomerApi.binding.js';
export { customerUserPatchRequestValidate, customerUserPatchResponseValidate, customerUserPublicSearchRequestValidate, customerUserPublicSearchResponseValidate, customerUserSearchResponseValidate, molliePaymentWebhookRequestValidate, } from './customer/CustomerUserApi.binding.js';
export {} from './customer/CustomerUserApi.js';
export { invoiceSearchResponseValidate, } from './invoice/InvoiceApi.binding.js';
export { invoiceState, } from './invoice/InvoiceApi.js';
export { getLanguages, } from './languages.js';
export * from './router/legacyPrefixRewrite.js';
export * from './router/localeRewrite.js';
export * from './router/router.js';
export * from './router/translatedRoutesRewrite.js';
export { guessLocale, guessLocaleFromLanguages, isSupportedLocale, localeToLanguages, supportedLocales, translation, } from './translation/translation.js';
export { importedTherapistsDeleteRequestValidate, importedTherapistsSearchRequestValidate, importedTherapistsSearchResponseValidate, } from './user/ImportedTherapistsApi.binding.js';
export { getCustomerByPermission, hasAnyPermission, permissionsOptions, } from './user/Permission.js';
export { postClientRequestValidate, searchTherapistRequestValidate, searchTherapistResponseValidate, } from './user/UserApi.binding.js';
export { coverageTypes, genderToSalutation, genderType, getAboutName, invoiceDigitalType, locationType, pricing, publicVisibilityType, Roles, salutation, searchTherapistSortType, treatmentMethodType, userClientOpenApiFields, userCommonOpenApiFields, userInsuranceType, userJobTitleType, userSpecialistOpenApiFields, } from './user/UserApi.js';
export { searchTherapistSearchParamsValidateCoercing, } from './user/UserApiCoercing.binding.js';
export { nonEmptyEmail, nonEmptyString, nonNullableBoolean, nullableBoolean, nullableDecimalAsString, nullableEnum, nullableNonEmptyEmail, nullableNonEmptyString, nullableNumber, nullableString, pagedSchemaOld, } from './validator.js';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function Api({ baseUrl }) {
    return {
        auth: {
            login: {
                validateRequest: loginRequestValidate,
                request: apiCall('POST', `${baseUrl}/api/auth/login`),
            },
        },
        common: {
            version: {
                request: partialBind(version, baseUrl),
            },
            config: {
                request: apiCall('POST', `${baseUrl}/api/common/config`, {
                    retry: [0, 100, 200, 700],
                }),
            },
            error: {
                url: `${baseUrl}/api/common/client-errors`,
            },
        },
        principal: {
            resetPassword: {
                request: apiCall('POST', `${baseUrl}/api/user/reset-password`),
            },
        },
        client: {
            register: {
                requestTan: {
                    request: apiCall('POST', `${baseUrl}/api/client/register/request-tan`),
                },
                request: apiCall('POST', `${baseUrl}/api/client/register`),
            },
            account: {
                delete: {
                    request: apiCall('DELETE', `${baseUrl}/api/client/account`),
                },
                document: {
                    search: {
                        request: apiCall('POST', `${baseUrl}/api/client/account/document`, {
                            retry: [0, 100, 200],
                        }),
                    },
                    download(type, id, filename, action) {
                        const url = `${baseUrl}/api/client/account/document/${type}/${id}/download/${filename}`
                            + (action ? `?action=${action}` : '');
                        return {
                            url,
                        };
                    },
                },
                invoice: {
                    search: {
                        request: apiCall('POST', `${baseUrl}/api/client/account/invoice`, {
                            retry: [0, 100, 200],
                        }),
                    },
                    download(type, id, filename, action) {
                        const url = `${baseUrl}/api/client/account/invoice/${type}/${id}/download/${filename}`
                            + (action ? `?action=${action}` : '');
                        return {
                            url,
                        };
                    },
                },
            },
            therapist: {
                search: {
                    request: partialBind(searchTherapist, baseUrl),
                },
            },
            appointment: {
                book: {
                    validateRequest: appointmentBookRequestValidate,
                    request: partialBind(appointmentBook, baseUrl),
                },
                bookable: {
                    request: partialBind(searchBookableAppointments, baseUrl),
                },
            },
            invoice: {
                requestTan: {
                    request: partialBind(clientInvoiceDownloadRequestTan, baseUrl),
                },
                download: {
                    request: partialBind(clientInvoiceDownloadInvoice, baseUrl),
                },
            },
        },
        customer: {
            map: {
                url: (customerId) => `${baseUrl}/api/customer/${customerId}/map`,
            },
        },
        customerUser: {
            publicSearch: {
                request: apiCall('POST', `${baseUrl}/api/customer-user/public-search`, {
                    retry: [0, 100, 200],
                }),
            },
        },
        therapist: {
            imported: {
                search: {
                    request: partialBind(importedTherapistsSearch, baseUrl),
                },
                remove: {
                    request: partialBind(importedTherapistsDelete, baseUrl),
                },
            },
        },
    };
}
//# sourceMappingURL=index.js.map